import { ROUTES } from '@constants'

import type { RouteStrategy, RouteStrategyParams } from './routeStrategy'

export class DiagramRoute implements RouteStrategy {
  public getRedirectPath(params: RouteStrategyParams): string | undefined {
    const { code } = params

    if (!code) {
      console.warn('Code is required to redirect to config')

      return
    }

    return `${ROUTES.DIAGRAMS_EDIT}/${code}`
  }
}
